import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { getTicketState, getTicketStateName } from '@tickets/helpers/ticketState';
import { BetStateEnum, BetStateViewEnum } from '@app/dev/constants/enums/betState';
import { BET_BUILDER } from '@tickets/constants';
import { useTranslation } from '@common/hooks/translation';

export const BetStatus = ({ data, isJustText }) => {
  const t = useTranslation();
  if (!data) return null;

  const { stateEnum, ticketState } = getTicketStateName(data);
  const hasGift = ticketState === BetStateEnum.Lost && !!data?.dataFromSwarm.win_amount;

  return (
    <p className={classnames('sport-status', `status-${stateEnum.toLowerCase()}`, { 'status-gift': hasGift }, { 'status-just-text': isJustText })}>
      {hasGift && <i className="icon-gift" />}
      {t(stateEnum) || data.dataFromSwarm?.state_name}
    </p>
  );
};

BetStatus.propTypes = {
  data: PropTypes.object,
  isJustText: PropTypes.bool,
};

export const DetailBetStatus = ({ data, isJustText }) => {
  const t = useTranslation();
  const { dataFromSwarm } = data;
  const ticketState = getTicketState({ bet_state_id: dataFromSwarm?.state_id || data?.state });
  const ticketStatus = dataFromSwarm?.type_name === BET_BUILDER
    ? BetStateViewEnum[ticketState]
    : BetStateViewEnum[ticketState] || data?.state_name;
  return <p className={classnames('ticket-info-white sport-status', BetStateViewEnum[ticketState], { 'status-just-text': isJustText })}>{t(ticketStatus)}</p>;
};

DetailBetStatus.propTypes = {
  data: PropTypes.object,
  isJustText: PropTypes.bool,
};
